import React from 'react'
import {ModalBase} from '../../components/Modals/ModalBase'

const ModalConfirmacionCuenta = (props: any) => {
  return (
    <ModalBase Styles={{maxWidth: '450px', width: '45%'}}>
      <div className='modal-card'>
        <div className='modal-content'>
          <div className='w-layout-hflex'>
            <h3 className='card-title l'>Verificación de cuenta</h3>
          </div>
          <div className='form-separator'></div>
          <p>Su cuenta ha sido verificada exitosamente</p>
          <div className='form-separator'></div>
          <div className='w-layout-hflex button-actions'>
            <button className='m button w-inline-block' onClick={props.handleClose}>
              <div>Aceptar</div>
            </button>
          </div>
        </div>
      </div>
    </ModalBase>
  )
}

export default ModalConfirmacionCuenta
